import { alchemyProvider } from 'wagmi/providers/alchemy';
import { publicProvider } from 'wagmi/providers/public';
import { Chain, getDefaultWallets } from '@rainbow-me/rainbowkit';
import { mainnet } from 'wagmi/chains';

import { configureChains, createConfig } from 'wagmi';

export interface IConfiguration {
  config: ReturnType<typeof createConfig>;
  chains: Chain[];
}

async function createConfiguration(): Promise<IConfiguration> {
  const { chains, publicClient } = configureChains(
    [mainnet],
    [
      alchemyProvider({
        apiKey: process.env.REACT_APP_ALCHEMY_ID!,
      }),
      publicProvider(),
    ]
  );

  const { connectors } = getDefaultWallets({
    appName: 'Kaikai Kiki',
    projectId: process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID!,
    chains,
  });

  const wagmiConfig = createConfig({
    autoConnect: true,
    connectors,
    publicClient,
  });
  return { config: wagmiConfig, chains } as IConfiguration;
}

export default createConfiguration;
